module.exports = __webpack_public_path__ + "img/3_198.b426837c.png";